import fetch from '../lib/fetch'

// API
var API_1 = process.env.API_1
// web
var API_2 = process.env.API_2

export default {
  API_1: API_1,
  API_2: API_2
}

// 获取验证权限列表
export const getPermissionValid = params => {
  return fetch({
    host: API_1,
    url: '/api/v1/common/permissionValid',
    method: 'get',
    params
  })
}

// 获取门店列表
export const getWxConfig = params => {
  return fetch({
    host: API_1,
    url: '/wechat/wxConfig',
    method: 'get',
    params
  })
}

// 获取门店列表
export const qiniuToken = params => {
  return fetch({
    host: API_2,
    url: '/api/v1/common/opinionToken',
    method: 'post',
    params
  })
}

// 获取讲堂详情
export const getBanners = params => {
  return fetch({
    host: API_2,
    url: '/api/v1/common/banners',
    method: 'get',
    params
  })
}

// 获取门店列表
export const deptList = () => {
  return fetch({
    host: API_1,
    url: '/api/v1/common/getDeptList',
    method: 'get'
  })
}

// 保存基本面试数据
export const getResume = () => {
  return fetch({
    host: API_1,
    url: '/user/resume',
    method: 'get'
  })
}

// 保存基本面试数据
export const resume = params => {
  return fetch({
    host: API_1,
    url: '/user/resume',
    method: 'post',
    params
  })
}

// 保存面试人员其他数据
export const resumePerfect = params => {
  return fetch({
    host: API_1,
    url: '/user/resumePerfect',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js